import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Site e-commerce`}</h2>
    <p>{`Je réalise de votre site e-commerce avec ou sans le `}<strong parentName="p">{`JAMstack`}</strong>{` pour augmenter votre `}<strong parentName="p">{`taux de conversion`}</strong>{` ! Que vous préfériez un développement à 100% par mes soins avec Node.js et Next.js ou pouvoir intégrer votre `}<strong parentName="p">{`plateforme favorite`}</strong>{` comme Shopify et consorts avec le `}<strong parentName="p">{`JAMstack`}</strong>{`, le choix est votre ! `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      